import React from "react";
import { navigate } from "gatsby";
import PreParser from "../../preParser";
import PostTitle from "./post-title";
import PostDate from "./post-date";
import PostFeaturedImage from "./post-featured-image";
import PostTerms from "./post-terms";
import PostExcerpt from "./post-excerpt";
const Post = (props) => {
    const handleClick = (event) => {
        if (event.target.nodeName.toLowerCase() === "a") {
            return;
        }
        navigate(props.uri);
    };
    return (React.createElement("article", { className: props.className, style: { ...props.style, order: props.index }, onClick: handleClick },
        React.createElement(PreParser, { structure: props.innerBlocks },
            React.createElement(PostTitle, { uri: props.uri }, props.title),
            React.createElement(PostExcerpt, { title: props.title, uri: props.uri }, props.excerpt),
            React.createElement(PostFeaturedImage, null, props.featuredImage ? props.featuredImage.node : undefined),
            React.createElement(PostDate, null, props.date),
            React.createElement(PostTerms, { asList: false, asLink: true }, props.categories.nodes))));
};
export default Post;
